import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import Speechmark from "./Speechmark";
import AnimatedText from "./AnimatedText";
import { useAppSelector } from "../../../hooks";
import t from "../../../helper/t";

const RootDiv = styled.div([
    {
        zIndex: 1000,
        marginLeft: 32,
        marginRight: 32,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,

        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        justifyContent: "center",
    }
]);

const AnimationDiv = styled.div([
    {
        height: 300,
    }
]);

interface WaitingWidgetProps { }

const WaitingWidget: React.FC<WaitingWidgetProps> = () => {

    const [isVisible, setVisible] = useState(false);

    const errorState = useAppSelector(state => state.error);

    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            setVisible(true);
        }, 1e3);

        return function tearDown() {
            window.clearTimeout(timeoutId);
        }
    }, []);

    return (
        <RootDiv>
            {isVisible && errorState.lastError === null && (
                <>
                    <div style={{ height: "calc(100% - 182px)" }} />
                    <AnimationDiv>
                        <Speechmark />
                    </AnimationDiv>
                    <div style={{ height: "100%" }}>
                        <div style={{ marginTop: 24, minHeight: 25 }}>
                            <AnimatedText messages={[t("Deine Daten laden noch."), t("Fast fertig."), t("Es dauert noch ein bisschen.")]} />
                        </div>
                    </div>
                </>
            )}
        </RootDiv>
    )
}

export default WaitingWidget;